import React from 'react';
import * as util from '../../../../../utils/EnumMapping';
import { tabs } from '../VacationUtil';
import LinkTab from '../../../../common/tab/TabNav.js';

import 'moment-timezone'
import NewVacationForDates from './NewVacationForDates.js';
import MyCalendar from '../../../../common/calendar/MyCalendar.js';


function VacationCalendar() {

    const enrich = (response) => {
        const events = [];
        // console.log(response);
        response.data.map((vac) =>
            events.push({
                id: vac.publicId,
                title: vac.employeeName + ' ' + util.getLabel(util.vacationTypes, vac.type).toLowerCase(),
                start: new Date(vac.startDate),
                end: new Date(vac.endDate),
                hexColor: vac.type === 'VACATION' ? '81d8d0' : 'cd7f5f',
                allDay: 'true'
            }));
        // console.log(events);
        return events;
    }

    return (
        <>
            <LinkTab tabs={tabs} index={2} />
            <MyCalendar
                enrich={(response) => enrich(response)}
                newEventApi={'/api/vacations'}
                newEventDialogTitle={'Új szabadság'}
                newEventDialogContent={(startDate, endDate, refresh, close) => <NewVacationForDates start={startDate} end={endDate} refresh={refresh} close={close} />} />
        </>
    );

}

export default VacationCalendar;